// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__B-gqv","flexBoxBlk":"Navigation_flexBoxBlk__fPuqV"};